import { render, staticRenderFns } from "./StdItemTxtHelpList.vue?vue&type=template&id=a7775156&"
import script from "./StdItemTxtHelpList.vue?vue&type=script&lang=js&"
export * from "./StdItemTxtHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports